/**
 * RUN T — T-2 (client half). The typeahead's one request.
 *
 * PHI IS NOT IN THE URL, and this deliberately does NOT match the Patients
 * page. That page sends `GET /api/patients?search=<the typed text>` — a
 * patient's name in a query string, on every keystroke. It is mitigated
 * rather than avoided: logRedact masks `?search=` before morgan writes the
 * line. Masking the log does not un-send the URL: it still reaches nginx's
 * access log, any proxy in front, and the browser's own history.
 *
 * A typeahead fires that request every 250 ms while somebody types a
 * patient's name, so it would multiply exactly the exposure the redaction
 * exists to paper over. The brief allows a POST body or a hashed parameter;
 * a POST body is the honest one here, because partial-name search cannot be
 * satisfied by a hash (that is the whole reason listPatients decrypts and
 * filters). So: POST, body, no query string.
 */
import { api } from '@/lib/api';
import type { PatientSuggestion } from './patientSearch';

export const SUGGEST_PATH = '/patients/search-suggest';

interface SuggestResponse { results: PatientSuggestion[] }

export async function searchPatientSuggestions(query: string): Promise<PatientSuggestion[]> {
  const res = await api.post<SuggestResponse>(SUGGEST_PATH, { query });
  if (!res.success || !res.data) return [];
  return Array.isArray(res.data.results) ? res.data.results : [];
}
